<template>
	<div style="position: relative;">
		<BlStandaloneField type="tree" :options="treeOptions" v-model="value" @change="setFilter()" label=" " />
		<span v-if="value && value.length" class="suffix material-icons clear" @click="clear()" style="visibility: visible; margin-top: 10px;">remove_circle_outline</span>
	</div>
</template>

<script>
import { Api } from 'ModelBundle'

export default {
	name: 'BlListFilterTreeManyToOne',
	props: ['initialValue', 'metadata', 'options'],
	emits: ['blListFilterChange'],
	data() {
		return {
			value: null,
			loading: true,
			treeOptions: {}
		}
	},
	inject: ['blList'],
	created() {
		this.value = this.initialValue
		this.loadData()
		this.defaultFilterChangeSub = this.blList.defaultFiltersChange.subscribe(() => {
			if(!this.options.filters) {
				this.clear()
				this.loadData()
			}
		})
	},
	unmounted() {
		this.defaultFilterChangeSub.unsubscribe()
	},
	methods: {
		setFilter() {
			if(this.value) this.$emit('blListFilterChange', [[this.metadata.field.name + '.id', 'IN', this.value.split(',').map(v => parseInt(v))], this.value])
			else this.$emit('blListFilterChange', null)
		},
		clear() {
			this.value = null
			this.setFilter()
		},
		loadData() {
			this.loading = true
			this.treeOptions = {}

			let req = {}
			req['context("result"):s.internals.model.getTreeManyToOne("' + this.metadata.field.options.target + '", "' + (this.options.parent ? this.options.parent : 'parent') + '")'] = {
				result: 'local.result'
			}
			Api.post('api/structure/', req).then(resp => {
				this.treeOptions = {
					tree: resp.result
				}
				this.loading = false
			})
		}
	}
}
</script>

<style scoped lang="scss">
	span.suffix.clear {
		position: absolute;
		left: 100%;
		margin-left: -33px;
		top: 0;
		background-color: var(--bl-surface);
		cursor: pointer;
	}
</style>